<!-- TOAST ALERT -->

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
<p-toast></p-toast>

<section class="churchRegister">
    <!-- FORM REGISTER -->
    <div class="card p-col-12 p-m-2">

        <!-- BACK BUTTON -->
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left">
                <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left"
                    class="p-button-warning p-mr-2" (click)="goBack()"></button>
            </ng-template>
        </p-toolbar>


        <!-- TITTLE -->
        <h5 class="churchRegisterForm__title--normal">{{lbl_grant}} {{lbl_play_audio}}</h5>
        <!-- <div class="p-text-bold" style="color: red;">Accesos a guías solo por opción CXC3 / Access to guides only from CXC3 / Acesso aos guias apenas pela opção CXC3</div> -->
        
        <form [formGroup]="churchRegisterForm" class=" p-fluid p-formgrid p-grid">
            <div class="p-col-12 p-md-6">
                <div class="option_button p-field p-col-12 p-md-12">
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <!-- <p-radioButton name="guideType" value="G" [(ngModel)]="guideType" inputId="guides" [disabled]="true" -->
                            <p-radioButton name="guideType" value="G" [(ngModel)]="guideType" inputId="guides" [disabled]="method=='UPDATE'"
                                formControlName="guideType" (onClick)="changeListGuides($event)"></p-radioButton>
                        </span>
                        <input style="font-weight: bold;" type="text" disabled pInputText placeholder="{{lbl_guides}}">
                    </div>
                    <div class="p-inputgroup">
                        <span class="p-inputgroup-addon">
                            <p-radioButton name="guideType" value="F" [(ngModel)]="guideType" inputId="fg" [disabled]="method=='UPDATE'"
                                formControlName="guideType" (onClick)="changeListGuides($event)"></p-radioButton>
                        </span>
                        <input style="font-weight: bold;" type="text" disabled pInputText placeholder="{{lbl_future_guide}}">
                    </div>
                </div>
            </div>

            <div class="p-col-12 p-md-6">
                <div class="p-field p-col-12 p-md-12">
                    <span class="p-float-label">
                        <p-dropdown id="stateDptoProvinceInput" formControlName="guide" type="email"
                            aria-describedby="current-help" [options]="listPerson" [(ngModel)]="selectedGuide"
                            optionLabel="fullName" class="test" [disabled]="method=='UPDATE'"></p-dropdown>
                        <label htmlFor="stateDptoProvinceInput">{{lbl_name}}<span
                                *ngIf="!churchRegisterForm.controls['guide'].value" style="color:red">
                                (*)</span>
                        </label>
                    </span>
                </div>
            </div>

            <div class="p-col-12 p-md-6">
                <div class="p-field p-col-12 p-md-12">
                    <span class="p-float-label">
                        <p-dropdown id="stateDptoProvinceInput" formControlName="language" type="email"
                            aria-describedby="current-help" [options]="listLanguage" [(ngModel)]="selectedLanguage"
                            optionLabel="value" class="test" (onChange)="listTranslatedItems()"
                            [disabled]="method=='UPDATE'"></p-dropdown>
                        <label htmlFor="stateDptoProvinceInput">{{lbl_language}}<span
                                *ngIf="!churchRegisterForm.controls['language'].value" style="color:red">
                                (*)</span>
                        </label>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-12">
                    <span class="p-float-label">
                        <p-dropdown id="typeInput" formControlName="type" type="email" aria-describedby="current-help"
                            [options]="filteredItems" [(ngModel)]="selectedItem" placeholder="_" optionLabel="descri"
                            [disabled]="method=='UPDATE'"></p-dropdown>
                        <label htmlFor="typeInput">{{lbl_item}}<span *ngIf="!churchRegisterForm.controls['type'].value"
                                style="color:red"> (*)</span></label>
                    </span>

                </div>
            </div>

            <div class="p-col-12 p-md-6">
                <div class="p-field p-col-12 p-md-12">
                    <span class="p-float-label">
                        <p-calendar id="purchDate" [(ngModel)]="purchDate" [touchUI]="true" [readonlyInput]="true"
                            inputId="touchui" dateFormat="dd-mm-yy" formControlName="purchDate"
                            [disabled]="record && record.purchItmDwn.status=='A'?true:false"></p-calendar>
                        <label for="purchDate">{{lbl_order_date}}<span style="color:red"> (*)</span></label>
                    </span>
                </div>
                <div class="p-field p-col-12 p-md-12">
                    <span class="p-float-label" *ngIf="record && record.purchItmDwn.status=='A'">
                        <p-calendar id="endDate" [(ngModel)]="endDate" [touchUI]="true" [readonlyInput]="true"
                            inputId="touchui" dateFormat="dd-mm-yy" formControlName="endDate"></p-calendar>
                        <label for="endDate">{{lbl_ending_date}}<span style="color:red"> (*)</span></label>
                    </span>
                </div>
            </div>

            <!-- Spacer -->
            <div class="p-col-12 p-md-6"></div>


            <!-- Button -->
            <div class="p-field p-col-12 p-md-12 p-xl-2 p-lg-2 p-g-2 p-md-2">
                <div class="ui-float-label">
                    <button [disabled]="button_save" tabIndex="8" pButton pRipple type="button" icon="pi pi-plus"
                        label="{{lbl_save}}" class="p-button-raised p-button-success" (keyup.enter)="registerRecord($event)"
                        (click)="registerRecord($event)"></button>
                </div>
            </div>
            <!-- Button -->
            <div class="p-field p-col-12 p-md-12 p-xl-2 p-lg-2 p-g-2 p-md-2">
                <div class="ui-float-label">
                    <button                        
                        [disabled]="!record ||  !record.purchItmDwn ||  record.purchItmDwn.status!='N'?true:false"
                        tabIndex="8" pButton pRipple type="button" icon="pi pi-plus" label="{{lbl_approve}}"
                        class="p-button-raised p-button-success" (keyup.enter)="sendLink($event)"
                        (click)="sendLink($event)"></button>
                </div>
            </div>
            <!-- Button -->
            <div class="p-field p-col-12 p-md-12 p-xl-2 p-lg-2 p-g-2 p-md-2" style="padding-right: 1%;">
                <div class="ui-float-label">
                    <button [disabled]="button_delete" pButton pRipple type="button" icon="pi pi-trash" label="{{lbl_delete}}"
                        class="p-button-raised p-button-danger" (keyup.enter)="deleteRecord($event)"
                        (click)="deleteRecord($event)"></button>
                </div>
            </div>
        </form>
    </div>
</section>